import { render } from "./ConnectFanPageDialog.vue?vue&type=template&id=887a734a"
import script from "./ConnectFanPageDialog.vue?vue&type=script&lang=js"
export * from "./ConnectFanPageDialog.vue?vue&type=script&lang=js"

import "./ConnectFanPageDialog.vue?vue&type=style&index=0&id=887a734a&lang=scss&scope=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__